'use strict';
module.exports = require('./MultiSelect.vue');


//////////////////
// WEBPACK FOOTER
// ./~/primevue/multiselect/index.js
// module id = 418
// module chunks = 7